'use client';

import { ReactElement } from 'react';
import { usePriceAndFitmentContext } from 'app/[lang]/[esite]/contexts/price-and-fitment-context/price-and-fitment-context';
import { Conditional } from '@cat-ecom/pcc-components';

export interface TaxDisclaimerWrapperProps {
  children: ReactElement;
}

const TaxDisclaimerWrapper = ({
  children
}: TaxDisclaimerWrapperProps) => {
  const { priceAndAvailability } = usePriceAndFitmentContext();
  const { isGstAvailable } = priceAndAvailability ?? {};

  return <Conditional test={isGstAvailable}>{children}</Conditional>;
};

export default TaxDisclaimerWrapper;
